import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SweetAlertService {

  private customStyles = {
    container: 'custom-swal-container',
    title: 'custom-swal-title',
    content: 'custom-swal-content',
  };
  constructor() { }
  errorAlert(title, message, allowOutsideClick?){
    Swal.fire({
      /* title: 'Oops...',
      text: 'Something went wrong!', */
      title: title,
      //text: message,
      html : message,
      allowOutsideClick: allowOutsideClick,
      width: "1100px"
      
    })
  }

  successAlert(title){
    Swal.fire({
     // position: 'top-center',
      title: title,
      showConfirmButton: false,
      customClass: this.customStyles,   
         
    })
  }
  confirmation(message: string, callback: (confirmed: boolean) => void): void {
    // Example implementation using SweetAlert2
    Swal.fire({
      title: 'Confirm',
      text: message,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then((result) => {
      callback(result.isConfirmed);
    });
  }
  // successAlert(title){
  //   Swal.fire({
  //     position:'top-center',
  //     icon:'success',
  //     title:title,
  //     showConfirmButton:false,
  //     timer:1500

  //   })
  // }
}
